import { Fragment, type FC } from "react";
import type { PractitionerType, TaxonomyOption } from "cmw-client";
import { PractitionerType as PractitionerTypeTag } from "@/components/ui/practitioner-type";

export type ProfessionEntry = { type: PractitionerType; endorsements: TaxonomyOption[] };

type ProfessionListProps = {
  entries: ProfessionEntry[];
  className?: string;
  tagClassName?: string;
};

export const ProfessionList: FC<ProfessionListProps> = ({ entries, className, tagClassName }) => {
  if (entries.length === 0) return null;

  return (
    <span className={className}>
      {entries.map((entry, index) => (
        <Fragment key={entry.type}>
          {index > 0 && ", "}
          <PractitionerTypeTag type={entry.type} endorsements={entry.endorsements} className={tagClassName} />
        </Fragment>
      ))}
    </span>
  );
};
